import * as React from 'react';
import { useState, useMemo } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid2';

// Tu JSON con modelos por persiana
const modelosPorPersiana = {
  "Enrollable": [
    "Allegra (Traslúcida)", "Bellini (Traslúcida)", "Casablanca (Traslúcida)", "Country (Traslúcida)", "Frost (Traslúcida)", "Kiara (Traslúcida)", "Loreto (Traslúcida)", "Niagara (Traslúcida)", "Oasis (Traslúcida)", "Valerie (Traslúcida)", "Vizela (Traslúcida)",
    "Eco Screen (Screen)", "Elegance Screen 1500 (Screen)", "Elegance Screen 2500 (Screen)", "Elegance Screen 3000 (Screen)", "Elegance Screen 3% (Screen)", "Elegance Screen 4500 (Screen)", "Phifer 2000 (Screen)", "Phifer 2100 (Screen)", "Phifer 4500 New 5% (Screen)", "Phifer Exterior (Screen)", "Solar Screen 3% (Screen)", "Solar Screen 4500 (Screen)",
    "Alessandria (Blackout)", "Arianne (Blackout)", "Casablanca (Blackout)", "Cleveland (Blackout)", "Columbia (Blackout)", "Contura (Blackout)", "Dakota (Blackout)", "Danzi (Blackout)", "Duplex (Blackout)", "Frost (Blackout)", "London (Blackout)", "Loreto (Blackout)", "Napa (Blackout)", "Niagara (Blackout)", "Marina (Blackout)", "Monaco (Blackout)", "Queens (Blackout)", "Toscana (Blackout)", "Valerie (Blackout)", "Wideshade (Blackout)"
  ],
  "Sheer Elegance": [
    "Burnet", "Chroma", "Contempo", "Contempo XL", "Coral", "Dusk", "Dusk Large", "Madeira Plain (Room Darkening)", "Madeira (Room Darkening)", "Manhattan", "Milán (Room Darkening)", "Organdi", "Plane", "Provenza", "Room Darkening Linen (Room Darkening)", "Room Darkening Livex (Room Darkening)", "Sense", "Shadow (Room Darkening)", "Shadow Large (Room Darkening)", "Siena", "Sundown (Room Darkening)", "Sundown Large (Room Darkening)", "Valencia (Room Darkening)", "Woodland", "Woodland Large"
  ],
  "Romana": [
    "Allegra (Traslúcida)", "Bellini (Traslúcida)", "Casablanca (Traslúcida)", "Country (Traslúcida)", "Frost (Traslúcida)", "Kiara (Traslúcida)", "Loreto (Traslúcida)", "Niagara (Traslúcida)", "Oasis (Traslúcida)", "Valerie (Traslúcida)", "Vizela (Traslúcida)",
    "Eco Screen (Screen)", "Elegance Screen 1500 (Screen)", "Elegance Screen 2500 (Screen)", "Elegance Screen 3000 (Screen)", "Elegance Screen 3% (Screen)", "Elegance Screen 4500 (Screen)", "Phifer 2000 (Screen)", "Phifer 2100 (Screen)", "Phifer 4500 New 5% (Screen)", "Phifer Exterior (Screen)", "Solar Screen 3% (Screen)", "Solar Screen 4500 (Screen)",
    "Alessandria (Blackout)", "Arianne (Blackout)", "Casablanca (Blackout)", "Cleveland (Blackout)", "Columbia (Blackout)", "Contura (Blackout)", "Dakota (Blackout)", "Danzi (Blackout)", "Duplex (Blackout)", "Frost (Blackout)", "London (Blackout)", "Loreto (Blackout)", "Napa (Blackout)", "Niagara (Blackout)", "Marina (Blackout)", "Monaco (Blackout)", "Queens (Blackout)", "Toscana (Blackout)", "Valerie (Blackout)", "Wideshade (Blackout)"
  ],
  "Panel": [
    "Allegra (Traslúcida)", "Bellini (Traslúcida)", "Casablanca (Traslúcida)", "Country (Traslúcida)", "Frost (Traslúcida)", "Kiara (Traslúcida)", "Loreto (Traslúcida)", "Niagara (Traslúcida)", "Oasis (Traslúcida)", "Valerie (Traslúcida)", "Vizela (Traslúcida)",
    "Eco Screen (Screen)", "Elegance Screen 1500 (Screen)", "Elegance Screen 2500 (Screen)", "Elegance Screen 3000 (Screen)", "Elegance Screen 3% (Screen)", "Elegance Screen 4500 (Screen)", "Phifer 2000 (Screen)", "Phifer 2100 (Screen)", "Phifer 4500 New 5% (Screen)", "Phifer Exterior (Screen)", "Solar Screen 3% (Screen)", "Solar Screen 4500 (Screen)",
    "Alessandria (Blackout)", "Arianne (Blackout)", "Casablanca (Blackout)", "Cleveland (Blackout)", "Columbia (Blackout)", "Contura (Blackout)", "Dakota (Blackout)", "Danzi (Blackout)", "Duplex (Blackout)", "Frost (Blackout)", "London (Blackout)", "Loreto (Blackout)", "Napa (Blackout)", "Niagara (Blackout)", "Marina (Blackout)", "Monaco (Blackout)", "Queens (Blackout)", "Toscana (Blackout)", "Valerie (Blackout)", "Wideshade (Blackout)"
  ],
  "Shangri-La": [
    "Versalles", "Toulousse"
  ],
  "Celular": [
    "Sheer New", "3/4 Blackout (Blackout)", "3/4 Traslúcida (Traslúcida)", "3/4 Elemental Light Filtering (Traslúcida)", "3/4 Elemental Black Out (Blackout)", "Print Light Filtering (Traslúcida)", "Print BO Sheer New (Blackout)"
  ],
  "Celular Coulisse": [
    "Cordless", "Cordless TDBU", "Infinity", "Infinity TDBU", "Cordlock", "Motorizada", "Motorizada TDBU", "Blackout (Blackout)", "Traslúcida (Traslúcida)"
  ],
  "Horizontal 2\"": [
    "Universal Pania Escalerilla"
  ],
  "Aluminio": [
    "Perforada", "Metálica", "Tradicional"
  ]
}


export default function SelectorPersianas({ onChange }) {
  const [persiana, setPersiana] = useState(null);
  const [opcionFinal, setOpcionFinal] = useState(null);

  const opcionesPersiana = useMemo(
    () => Object.keys(modelosPorPersiana).sort(),
    []
  );

  const opcionesModelo = useMemo(() => {
    if (!persiana) return [];
    return modelosPorPersiana[persiana] ?? [];
  }, [persiana]);

  const handlePersianaChange = (_, nuevaPersiana) => {
    setPersiana(nuevaPersiana);
    setOpcionFinal(null);
  };

  const handleModeloChange = (_, nuevoModelo) => {
    if (persiana && nuevoModelo) {
      const combinado = `${persiana} - ${nuevoModelo}`;
      setOpcionFinal(combinado);
      if (onChange) onChange(combinado);
    }
  };

  return (
    <Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 4, sm: 10, md: 12 }} className="mt-0">
      {/* Autocomplete de Persiana */}
      <Grid size={{ xs: 4, sm: 5, md: 6 }}>
      <Autocomplete
        options={opcionesPersiana}
        value={persiana}
        onChange={handlePersianaChange}
        size="small"
        color={"blueRA"}
        renderInput={(params) => (
          <TextField {...params} label="Persiana" placeholder="Selecciona una persiana…" />
        )}
        clearOnEscape
      />
      </Grid>

      {/* Autocomplete de Modelo dependiente */}
      <Grid size={{ xs: 4, sm: 5, md: 6 }}>
      <Autocomplete
        options={opcionesModelo}
        size="small"
        color={"blueRA"}
        value={
          opcionFinal
            ? opcionFinal.replace(`${persiana} - `, '')
            : null
        }
        onChange={handleModeloChange}
        disabled={!persiana}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Modelo"
            placeholder={persiana ? 'Selecciona un modelo…' : 'Primero elige una persiana'}
          />
        )}
        noOptionsText={persiana ? 'Sin modelos' : 'Selecciona una persiana'}
        clearOnEscape
      />
      </Grid>
    </Grid>
  );
}
